import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FloatingNavigationService } from '../../services/floating-navigation/floating-navigation.service';
import { ScrollDispatcher, CdkScrollable } from '@angular/cdk/overlay';
import { BehaviorSubject } from 'rxjs';
import { FloatingNavigationModel } from '../../models/floating-navigation.model';
import { Router, UrlTree, NavigationExtras } from '@angular/router';
import { GoogleAnalyticsService } from '@shared/services';

@Component({
  selector: 'dls-page-navigation',
  templateUrl: './page-navigation.component.html',
  styleUrls: ['./page-navigation.component.scss']
})
export class PageNavigationComponent implements OnInit {

  navigationItems: BehaviorSubject<FloatingNavigationModel[]>;
  currentSection: number;
  previousSection: number;
  elemHeights: Array<number>;

  constructor(
    private floatingNavSrvc: FloatingNavigationService,
    private scrollDispatcher: ScrollDispatcher,
    private cd: ChangeDetectorRef,
    private _router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {

    this.navigationItems = new BehaviorSubject<FloatingNavigationModel[]>([]);
    this.elemHeights = [];

    // To select the first item by default
    this.currentSection = this.previousSection = 0;

    // Get the navItems
    this.floatingNavSrvc
      .getFloatingNavItems()
      .subscribe((navItems: FloatingNavigationModel[]) => {
        // Get the position of each nav sections

        // To set the first element in nav items position to 0(TOP)
        if (navItems[0]) {
          navItems[0].elementOffsetTop = 0;
        }

        // Extract all the heights
        this.elemHeights = navItems.map((value: FloatingNavigationModel) => {
          return value.elementOffsetTop;
        });

        // Render the nav list
        this.navigationItems.next(navItems);
      });
  }

  ngOnInit() {
    // To get the container current scroll position
    this.scrollDispatcher.scrolled().subscribe((data: CdkScrollable) => {
      // Store the current highlighted section
      this.previousSection = this.currentSection;

      // Update the activated section
      this.currentSection = this.onWindowScroll(data);

      // Detect changes only when activated section updates
      if (this.currentSection !== this.previousSection) {
        this.cd.detectChanges();
      }
    });
  }

  private onWindowScroll(data: CdkScrollable): number {
    const scrollTop = data.getElementRef().nativeElement.scrollTop || 0;

    let activeSection = -1;

    // Get the current section to be highlighted
    for (let navItem = this.elemHeights.length; navItem >= 0; --navItem) {
      if (scrollTop >= this.elemHeights[navItem]) {
        activeSection = navItem;
        break;
      }
    }
    return activeSection;
  }

  public navSelected(nav: FloatingNavigationModel): void {
    // Scroll into view
    this.floatingNavSrvc.setScrollHeight(nav.elementOffsetTop);
    this.updateURLWithFragment(nav.id);

    const path = `Right Nav > ${nav.title}`;
    this.googleAnalyticsService.trackPageEvents('click', path.toUpperCase());
  }

  // Performs a navigation to same page with added page fragment
  private updateURLWithFragment(fragment: string): void {
    const currentUrlTree: UrlTree = this._router.createUrlTree([], <NavigationExtras>{ fragment: fragment });
    // Sets the section fragment to the URL
    this._router.navigateByUrl(currentUrlTree);
  }

}
